<template>
  <BaseButton primary :disabled="isLoading || isRejected" @click="exportOrders">
    {{ isRejected ? rejectReason : 'Export' }}
  </BaseButton>
</template>

<script>
import { omit } from 'lodash-es';
import { accountAccOrdersClient } from '@/api/clients';

const IDLE = 'IDLE';
const LOADING = 'LOADING';
const RESOLVED = 'RESOLVED';
const REJECTED = 'REJECTED';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      status: IDLE,
      rejectReason: '',
    };
  },
  computed: {
    isLoading() {
      return this.status === LOADING;
    },
    isRejected() {
      return this.status === REJECTED;
    },
  },
  methods: {
    setStatus(status) {
      this.status = status;
    },
    async exportOrders() {
      try {
        this.setStatus(LOADING);

        const response = await accountAccOrdersClient.export(this.accountId, {
          ...omit(this.query, ['include']),
          include: 'contact',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', 'acc_orders.xlsx');
        link.click();

        window.URL.revokeObjectURL(url);

        this.setStatus(RESOLVED);
      } catch (error) {
        this.rejectReason = error?.response?.message || 'Export failed';
        this.setStatus(REJECTED);
      }
    },
  },
};
</script>
